import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from "@angular/router";
import {Observable} from "rxjs";
import {EndpointsProvider} from "../../umbrella-common/endpoints/endpoint-provider.service";

@Injectable({providedIn: "root"})
export class SalespeopleResolver implements Resolve<string[]> {

	constructor(private endpoints: EndpointsProvider) {
	}

	resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<string[]> {
		return this.endpoints.common.getSalesPeople();
	}
}
